import React, { useEffect, useState } from 'react';
import {
    EMPTY_ARRAY,
    PasswordPolicies,
    PasswordPoliciesList,
} from '../../constants';
import { CompaniesByUserModel } from '../../models';
import { AuthenticatedUserModel } from '../../models/security';
import { CompaniesAPI } from '../../services/external/APIs';

/**
 * Obtenemos todas las compañias a las que el usuario esta asociado y las politicas del cambio de contraseña
 * @param userInfo AuthenticatedUserModel
 * @returns CompaniesByUserModel[]
 * @returns PasswordPolicies[]
 */
export const UseGetCompaniesList = (userInfo: AuthenticatedUserModel) => {
    const [companies, setCompanies] = useState<CompaniesByUserModel[]>(EMPTY_ARRAY);
    const [passwordPolicies, setPasswordPolicies] =
        useState<PasswordPolicies[]>(EMPTY_ARRAY);

    useEffect(() => {
        CompaniesAPI.getCompaniesByUser(userInfo.id).then((res) => {
            setCompanies(res);
        });
        setPasswordPolicies(PasswordPoliciesList);
    }, []);

    return { companies, passwordPolicies };
};
